import {redirectUrlMap} from '@client/util/constants/redirectUrl';

/**
 * This method help handle sso redirect based on incoming query params relevant for redirect;
 * It is expected that following query params be available:
 * sso_redirect_page - this would contain the page where the redirect shall happen to. For e.g. 'performance' would redirect to performance page
 * @param routeQueryParam
 */
export const handleSsoRedirectRequest = (routeQueryParam: Record<string, string>): void => {
  if (routeQueryParam.sso_redirect_page) {
    const ssoRedirectPage = routeQueryParam.sso_redirect_page;

    if (redirectUrlMap.has(ssoRedirectPage)) {
      localStorage.setItem('SSO_REDIRECT_PAGE', ssoRedirectPage);
    }
  }
};

/**
 * Method to get redirect uri for sso redirect
 * @returns string - redirect value
 */
export const getSsoRedirectUri = (): string => {
  let redirectUri = '';

  if (localStorage.getItem('SSO_REDIRECT_PAGE')) {
    const ssoRedirectUri = localStorage.getItem('SSO_REDIRECT_PAGE');

    if (redirectUrlMap.has(ssoRedirectUri)) redirectUri = redirectUrlMap.get(ssoRedirectUri);

    localStorage.removeItem('SSO_REDIRECT_PAGE');
  }

  return redirectUri;
};
